import { FlowTask } from "@/controllers/flow";

/**
 * CIDログイン誘導モーダルを表示するタスク。
 * - 拒否ボタン押下で `done(false)` を返して分岐に利用します
 */
export class CIDConfirmTask extends FlowTask {
  constructor() {
    super();
    this.rejectButtonButtonElement = document.querySelector("#reject-login-button");
    this.modal = $("[data-remodal-id=modalCidLogin]").remodal({
      hashTracking: false,
      closeOnEscape: false,
      closeOnOutsideClick: false,
      modifier: "remodal-cid-login"
    });
  }

  async flowProcess(done) {
    this.onReject = () => done(false);

    this.rejectButtonButtonElement.addEventListener("click", this.onReject);
    this.modal.open();
  }

  deinitialize() {
    this.rejectButtonButtonElement.removeEventListener("click", this.onReject);
    this.modal.close();
  }
}
